import { z } from 'zod';
/** Which Kirin client a `/api/releases/check` query refers to (KIR-2962). */
export const clientKindSchema = z.enum(['agent', 'cursor_ext', 'copilot_ext']);
// KIR-2962 / KIR-4025: latest available version per Kirin client, served by
// GET /api/releases/latest. The backend fetches + caches these from the release
// pipeline (agent) and the extension marketplaces (Cursor/Copilot) so every
// client and the dashboard read one shared answer.
/** Where a "latest" answer came from — for debugging / provenance. */
export const releaseSourceSchema = z.enum([
    'manifest', // authoritative GA manifest (latest.json) — KIR-4275
    'openvsx', // fallback: OpenVSX (published = GA)
]);
/** Latest release info for one client. */
export const clientReleaseSchema = z.object({
    /** Latest published/released version; null when the source is unavailable. */
    latestVersion: z.string().nullable(),
    /** Where to get it: the agent installer URL, or the extension's marketplace page. */
    downloadUrl: z.string().url().nullable(),
    source: releaseSourceSchema.nullable(),
});
/** Response of GET /api/releases/latest — latest per client. */
export const releasesLatestSchema = z.object({
    agent: clientReleaseSchema,
    cursor_ext: clientReleaseSchema,
    copilot_ext: clientReleaseSchema,
});
// KIR-2962 / KIR-4026: GET /api/releases/check — the comparator-less "am I
// behind?" endpoint for the Go agent (which has no semver) and the IDE. The
// caller passes its client + installed version; the backend returns the latest
// for that client plus a server-computed `updateAvailable`, so every endpoint
// renders a boolean rather than running its own comparator.
/** Query for GET /api/releases/check. `client` defaults to the agent. */
export const releaseCheckQuerySchema = z.object({
    installed: z.string().min(1),
    client: clientKindSchema.default('agent'),
});
/** Result of GET /api/releases/check for the caller's client. */
export const releaseCheckResultSchema = z.object({
    /** Latest version for the caller's client; null when the backend has none. */
    latestVersion: z.string().nullable(),
    /** True only when the installed version is confidently behind latest. */
    updateAvailable: z.boolean(),
});
//# sourceMappingURL=releases.js.map